// AUTO-GENERATED by scripts/generate-menu.ts. Do not edit by hand.
// Generated at: 2026-09-29T21:49:13.557Z
// Source: Supabase menu_item_prices (347 rows).

export const priceOverrides: Record<string, number> = {
  "chicken-souvlaki-pita-1": 14.95,
  "chicken-souvlaki-pita-2": 27.95,
  "chicken-souvlaki-plate-1": 18.95,
  "chicken-souvlaki-plate-2": 32.95,
  "delson-dinner-appetizers-butterfly-shrimp": 16.95,
  "delson-dinner-appetizers-dolmades": 9.95,
  "delson-dinner-appetizers-feta-olives": 10.95,
  "delson-dinner-appetizers-fried-calamari-1": 18.95,
  "delson-dinner-appetizers-fried-calamari-2": 23.95,
  "delson-dinner-appetizers-garlic-bread": 6.95,
  "delson-dinner-appetizers-garlic-cheese-bread": 10.95,
  "delson-dinner-appetizers-gratin-matane-shrimp": 10.95,
  "delson-dinner-appetizers-gratin-mushrooms": 9.95,
  "delson-dinner-appetizers-gratin-snails": 10.95,
  "delson-dinner-appetizers-lentil-greek-soup": 4.95,
  "delson-dinner-appetizers-marinated-artichokes": 9.95,
  "delson-dinner-appetizers-marinated-palms": 9.95,
  "delson-dinner-appetizers-pikilia-1": 18.95,
  "delson-dinner-appetizers-pikilia-2": 25.95,
  "delson-dinner-appetizers-pita-bread": 2,
  "delson-dinner-appetizers-scallops": 19.95,
  "delson-dinner-appetizers-soup-of-the-day": 4.95,
  "delson-dinner-appetizers-spanakopita": 9.95,
  "delson-dinner-appetizers-spicy-sausages": 16.95,
  "delson-dinner-appetizers-taramosalata": 9.95,
  "delson-dinner-appetizers-tzatziki": 9.95,
  "delson-dinner-beverages-cappuccino": 4.25,
  "delson-dinner-beverages-espresso": 3.25,
  "delson-dinner-beverages-filter-coffee": 2.95,
  "delson-dinner-beverages-juice": 2.95,
  "delson-dinner-beverages-milk": 2.95,
  "delson-dinner-beverages-soft-drink": 2.95,
  "delson-dinner-beverages-tea": 2.95,
  "delson-dinner-desserts-baklava": 4.95,
  "delson-dinner-desserts-cake-of-the-day": 3.95,
  "delson-dinner-desserts-creme-caramel": 4.95,
  "delson-dinner-desserts-galaktoboureko": 4.95,
  "delson-dinner-desserts-ice-cream": 3.95,
  "delson-dinner-desserts-pouding-chomeur": 3.95,
  "delson-dinner-desserts-rice-pudding": 3.95,
  "delson-dinner-extras-butterfly-shrimp": 3.95,
  "delson-dinner-extras-feta-cheese": 2.95,
  "delson-dinner-extras-langoustine": 3.95,
  "delson-dinner-extras-mushroom-sauce": 2,
  "delson-dinner-extras-pepper-sauce": 2,
  "delson-dinner-extras-scallop": 3.95,
  "delson-dinner-extras-taramosalata": 2,
  "delson-dinner-extras-tzatziki": 2,
  "delson-dinner-extras-vinaigrette": 2,
  "delson-dinner-kids-menu-chicken-nuggets-plate": 17.95,
  "delson-dinner-kids-menu-chicken-souvlaki": 18.95,
  "delson-dinner-kids-menu-gratin-lasagna": 16.95,
  "delson-dinner-kids-menu-gratin-spaghetti": 16.95,
  "delson-dinner-kids-menu-souvlaki-single": 16.95,
  "delson-dinner-kids-menu-spaghetti": 15.95,
  "delson-dinner-pasta-baked-lasagna": 22.95,
  "delson-dinner-pasta-baked-spaghetti": 22.95,
  "delson-dinner-pasta-spaghetti": 20.95,
  "delson-dinner-pitas-plate-chicken-souvlaki-1": 19.95,
  "delson-dinner-pitas-plate-chicken-souvlaki-2": 32.95,
  "delson-dinner-pitas-plate-gyro-1": 19.95,
  "delson-dinner-pitas-plate-gyro-2": 32.95,
  "delson-dinner-pitas-plate-pork-souvlaki-1": 18.95,
  "delson-dinner-pitas-plate-pork-souvlaki-2": 30.95,
  "delson-dinner-pitas-sandwich-chicken-souvlaki-1": 14.95,
  "delson-dinner-pitas-sandwich-chicken-souvlaki-2": 27.95,
  "delson-dinner-pitas-sandwich-gyro-1": 14.95,
  "delson-dinner-pitas-sandwich-gyro-2": 27.95,
  "delson-dinner-pitas-sandwich-pork-souvlaki-1": 13.95,
  "delson-dinner-pitas-sandwich-pork-souvlaki-2": 25.95,
  "delson-dinner-red-meat-cava-grecque-steak": 30.95,
  "delson-dinner-red-meat-filet-mignon-medallion": 35.95,
  "delson-dinner-red-meat-filet-mignon-skewer": 36.95,
  "delson-dinner-red-meat-lamb-chops": 34.95,
  "delson-dinner-red-meat-pepper-steak": 40.95,
  "delson-dinner-red-meat-ribeye-steak": 40.95,
  "delson-dinner-red-meat-sirloin-steak": 40.95,
  "delson-dinner-salads-caesar-salad": 16.95,
  "delson-dinner-salads-caesar-with-grilled-chicken": 24.95,
  "delson-dinner-salads-chef-salad": 16.95,
  "delson-dinner-salads-chef-salad-with-grilled-chicken": 24.95,
  "delson-dinner-salads-chef-salad-with-grilled-salmon": 24.95,
  "delson-dinner-salads-greek-salad": 20.95,
  "delson-dinner-salads-greek-salad-with-grilled-chicken": 28.95,
  "delson-dinner-salads-vegetarian-plate": 21.95,
  "delson-dinner-seafood-baked-salmon": 26.95,
  "delson-dinner-seafood-baked-white-fish": 23.95,
  "delson-dinner-seafood-breaded-white-fish": 25.95,
  "delson-dinner-seafood-butterfly-shrimp-plate": 30.95,
  "delson-dinner-seafood-calamari-and-butterfly-shrimp-plate": 32.95,
  "delson-dinner-seafood-fish-n-chips": 25.95,
  "delson-dinner-seafood-fisherman-plate": 48.95,
  "delson-dinner-seafood-fried-calamari-plate": 25.95,
  "delson-dinner-seafood-frog-legs": 30.95,
  "delson-dinner-seafood-grilled-scallops-plate": 34.95,
  "delson-dinner-seafood-langoustines-plate": 35.95,
  "delson-dinner-seafood-salmon-and-butterfly-shrimp-plate": 35.95,
  "delson-dinner-seafood-scallops-plate": 25.95,
  "delson-dinner-special-cava-chicken-skewer": 26.95,
  "delson-dinner-special-cava-chicken-souvlaki-2": 25.95,
  "delson-dinner-special-cava-grilled-chicken-fillet": 24.95,
  "delson-dinner-special-cava-moussaka": 26.95,
  "delson-dinner-special-cava-pork-chops": 22.95,
  "delson-dinner-special-cava-pork-souvlaki-2": 24.95,
  "delson-dinner-special-cava-shish-kebab": 24.95,
  "delson-dinner-surf-turf-chicken-brochette-butterfly-shrimp": 35.95,
  "delson-dinner-surf-turf-chicken-brochette-fried-calamari": 36.95,
  "delson-dinner-surf-turf-chicken-brochette-scallops": 36.95,
  "delson-dinner-surf-turf-filet-mignon-butterfly-shrimp": 42.95,
  "delson-dinner-surf-turf-grilled-chicken-butterfly-shrimp": 34.95,
  "delson-fish-and-chips": 24.95,
  "delson-lunch-appetizers-butterfly-shrimp": 16.95,
  "delson-lunch-appetizers-dolmades": 9.95,
  "delson-lunch-appetizers-feta-olives": 10.95,
  "delson-lunch-appetizers-fried-calamari-1": 18.95,
  "delson-lunch-appetizers-fried-calamari-2": 23.95,
  "delson-lunch-appetizers-garlic-bread": 6.95,
  "delson-lunch-appetizers-garlic-cheese-bread": 10.95,
  "delson-lunch-appetizers-gratin-matane-shrimp": 10.95,
  "delson-lunch-appetizers-gratin-mushrooms": 8.95,
  "delson-lunch-appetizers-gratin-snails": 10.95,
  "delson-lunch-appetizers-lentil-greek-soup": 4.95,
  "delson-lunch-appetizers-marinated-artichokes": 9.95,
  "delson-lunch-appetizers-marinated-palms": 9.95,
  "delson-lunch-appetizers-pikilia-1": 18.95,
  "delson-lunch-appetizers-pikilia-2": 25.95,
  "delson-lunch-appetizers-pita-bread": 2,
  "delson-lunch-appetizers-scallops": 19.95,
  "delson-lunch-appetizers-soup-of-the-day": 4.95,
  "delson-lunch-appetizers-spanakopita": 9.95,
  "delson-lunch-appetizers-spicy-sausages": 16.95,
  "delson-lunch-appetizers-taramosalata": 9.95,
  "delson-lunch-appetizers-tzatziki": 9.95,
  "delson-lunch-beverages-cappuccino": 4.25,
  "delson-lunch-beverages-espresso": 3.25,
  "delson-lunch-beverages-filter-coffee": 2.95,
  "delson-lunch-beverages-juice": 2.95,
  "delson-lunch-beverages-milk": 2.95,
  "delson-lunch-beverages-soft-drink": 2.95,
  "delson-lunch-beverages-tea": 2.95,
  "delson-lunch-desserts-baklava": 4.95,
  "delson-lunch-desserts-cake-of-the-day": 3.95,
  "delson-lunch-desserts-creme-caramel": 4.95,
  "delson-lunch-desserts-galaktoboureko": 4.95,
  "delson-lunch-desserts-ice-cream": 3.95,
  "delson-lunch-desserts-pouding-chomeur": 3.95,
  "delson-lunch-desserts-rice-pudding": 3.95,
  "delson-lunch-extras-butterfly-shrimp": 3.95,
  "delson-lunch-extras-feta-cheese": 2.95,
  "delson-lunch-extras-langoustine": 3.95,
  "delson-lunch-extras-mushroom-sauce": 2,
  "delson-lunch-extras-pepper-sauce": 2,
  "delson-lunch-extras-scallop": 3.95,
  "delson-lunch-extras-taramosalata": 2,
  "delson-lunch-extras-tzatziki": 2,
  "delson-lunch-extras-vinaigrette": 2,
  "delson-lunch-main-dishes-baked-salmon": 23.95,
  "delson-lunch-main-dishes-baked-white-fish": 18.95,
  "delson-lunch-main-dishes-breaded-white-fish": 20.95,
  "delson-lunch-main-dishes-butterfly-shrimp": 19.95,
  "delson-lunch-main-dishes-cava-grecque-steak": 29.95,
  "delson-lunch-main-dishes-chicken-2-butterfly-shrimp": 29.95,
  "delson-lunch-main-dishes-chicken-parmesan": 26.95,
  "delson-lunch-main-dishes-chicken-skewer": 24.95,
  "delson-lunch-main-dishes-chicken-souvlaki-1": 19.95,
  "delson-lunch-main-dishes-chicken-souvlaki-2": 25.95,
  "delson-lunch-main-dishes-filet-mignon-butterfly-shrimp": 40.95,
  "delson-lunch-main-dishes-filet-mignon-medallion": 34.95,
  "delson-lunch-main-dishes-filet-mignon-skewer": 34.95,
  "delson-lunch-main-dishes-fish-n-chips": 24.95,
  "delson-lunch-main-dishes-fried-calamari": 25.95,
  "delson-lunch-main-dishes-frog-legs": 22.95,
  "delson-lunch-main-dishes-grilled-chicken-filet": 23.95,
  "delson-lunch-main-dishes-hamburger-steak": 19.95,
  "delson-lunch-main-dishes-lamb-chops": 32.95,
  "delson-lunch-main-dishes-moussaka": 24.95,
  "delson-lunch-main-dishes-pork-chops": 21.95,
  "delson-lunch-main-dishes-pork-souvlaki-1": 18.95,
  "delson-lunch-main-dishes-pork-souvlaki-2": 24.95,
  "delson-lunch-main-dishes-salmon-butterfly-shrimp": 29.95,
  "delson-lunch-main-dishes-scallops": 22.95,
  "delson-lunch-main-dishes-shish-kebab": 24.95,
  "delson-lunch-main-dishes-spicy-sausages": 21.95,
  "delson-lunch-midi-plate-chicken-souvlaki-1": 19.95,
  "delson-lunch-midi-plate-chicken-souvlaki-2": 32.95,
  "delson-lunch-midi-plate-gyros-1": 19.95,
  "delson-lunch-midi-plate-gyros-2": 32.95,
  "delson-lunch-midi-plate-pork-souvlaki-1": 18.95,
  "delson-lunch-midi-plate-pork-souvlaki-2": 30.95,
  "delson-lunch-midi-sandwich-chicken-souvlaki-1": 14.95,
  "delson-lunch-midi-sandwich-chicken-souvlaki-2": 27.95,
  "delson-lunch-midi-sandwich-gyros-1": 14.95,
  "delson-lunch-midi-sandwich-gyros-2": 27.95,
  "delson-lunch-midi-sandwich-pork-souvlaki-1": 13.95,
  "delson-lunch-midi-sandwich-pork-souvlaki-2": 25.95,
  "delson-lunch-pasta-baked-lasagna": 22.95,
  "delson-lunch-pasta-baked-spaghetti": 22.95,
  "delson-lunch-pasta-spaghetti": 20.95,
  "delson-lunch-salads-caesar-grilled-chicken": 24.95,
  "delson-lunch-salads-caesar-salad": 16.95,
  "delson-lunch-salads-chef-salad": 16.95,
  "delson-lunch-salads-chef-salad-grilled-chicken": 24.95,
  "delson-lunch-salads-chef-salad-grilled-salmon": 24.95,
  "delson-lunch-salads-greek-salad": 20.95,
  "delson-lunch-salads-greek-salad-grilled-chicken": 28.95,
  "delson-lunch-salads-vegetarian-plate": 21.95,
  "dip-creamy-vinaigrette": 10.95,
  "dip-taramosalata": 10.95,
  "dip-tzatziki": 10.95,
  "gyro-pita-1": 14.95,
  "gyro-pita-2": 27.95,
  "gyro-plate-1": 18.95,
  "gyro-plate-2": 32.95,
  "meal-greek-potatoes": 10.95,
  "meal-house-rice": 14.95,
  "montreal-baklava": 4.95,
  "montreal-butterfly-shrimp-dinner": 19.95,
  "montreal-cake-day": 3.95,
  "montreal-cappuccino": 4.25,
  "montreal-chicken-breast-shrimp": 29.95,
  "montreal-chicken-brochette": 24.95,
  "montreal-chicken-parmesan": 26.95,
  "montreal-creme-caramel": 4.95,
  "montreal-dinner-baked-salmon": 26.95,
  "montreal-dinner-baked-white-fish": 23.95,
  "montreal-dinner-breaded-white-fish": 25.95,
  "montreal-dinner-butterfly-shrimp-4": 16.95,
  "montreal-dinner-butterfly-shrimp-plate": 30.95,
  "montreal-dinner-caesar-salad": 16.95,
  "montreal-dinner-caesar-salad-chicken": 24.95,
  "montreal-dinner-calamari-shrimp-plate": 32.95,
  "montreal-dinner-chef-salad": 16.95,
  "montreal-dinner-chef-salad-chicken": 24.95,
  "montreal-dinner-chef-salad-salmon": 24.95,
  "montreal-dinner-chicken-breast-shrimp": 34.95,
  "montreal-dinner-chicken-brochette": 26.95,
  "montreal-dinner-chicken-brochette-calamari": 36.95,
  "montreal-dinner-chicken-brochette-scallops": 36.95,
  "montreal-dinner-chicken-brochette-shrimp": 35.95,
  "montreal-dinner-chicken-souvlaki-2": 25.95,
  "montreal-dinner-dolmades": 9.95,
  "montreal-dinner-escargots": 10.95,
  "montreal-dinner-feta-olives": 10.95,
  "montreal-dinner-filet-mignon-brochette": 36.95,
  "montreal-dinner-filet-mignon-medallions": 35.95,
  "montreal-dinner-filet-mignon-shrimp": 42.95,
  "montreal-dinner-fisherman-plate": 48.95,
  "montreal-dinner-fried-calamari-1": 18.95,
  "montreal-dinner-fried-calamari-2": 23.95,
  "montreal-dinner-fried-calamari-plate": 25.95,
  "montreal-dinner-frog-legs": 30.95,
  "montreal-dinner-garlic-bread": 6.95,
  "montreal-dinner-garlic-bread-cheese": 10.95,
  "montreal-dinner-greek-lentil-soup": 4.95,
  "montreal-dinner-greek-salad-chicken": 28.95,
  "montreal-dinner-greek-salad-meal": 20.95,
  "montreal-dinner-grilled-chicken-breast": 24.95,
  "montreal-dinner-grilled-scallops-plate": 34.95,
  "montreal-dinner-hearts-of-palm": 9.95,
  "montreal-dinner-kids-chicken-nuggets": 15.95,
  "montreal-dinner-kids-chicken-souvlaki": 15.95,
  "montreal-dinner-kids-lasagna": 15.95,
  "montreal-dinner-kids-pork-souvlaki": 15.95,
  "montreal-dinner-kids-spaghetti": 15.95,
  "montreal-dinner-kids-spaghetti-baked": 15.95,
  "montreal-dinner-lamb-chops": 34.95,
  "montreal-dinner-langoustines-plate": 35.95,
  "montreal-dinner-marinated-artichokes": 9.95,
  "montreal-dinner-moussaka": 26.95,
  "montreal-dinner-mushrooms-gratinee": 9.95,
  "montreal-dinner-pepper-steak": 40.95,
  "montreal-dinner-pikilia-1": 18.95,
  "montreal-dinner-pikilia-2": 25.95,
  "montreal-dinner-pita-bread-single": 2,
  "montreal-dinner-pork-brochette": 24.95,
  "montreal-dinner-pork-chops": 22.95,
  "montreal-dinner-pork-souvlaki-2": 24.95,
  "montreal-dinner-ribeye-steak": 40.95,
  "montreal-dinner-salmon-shrimp-plate": 35.95,
  "montreal-dinner-scallops-app": 19.95,
  "montreal-dinner-scallops-plate": 25.95,
  "montreal-dinner-shrimp-matane": 10.95,
  "montreal-dinner-sirloin-steak": 40.95,
  "montreal-dinner-soup-day": 4.95,
  "montreal-dinner-spanakopita": 9.95,
  "montreal-dinner-spicy-sausages-app": 16.95,
  "montreal-dinner-steak-cava": 30.95,
  "montreal-dinner-taramosalata": 9.95,
  "montreal-dinner-tzatziki": 9.95,
  "montreal-espresso": 3.25,
  "montreal-extra-butterfly-shrimp": 3.95,
  "montreal-extra-feta": 2.95,
  "montreal-extra-frog-leg": 2.95,
  "montreal-extra-langoustine": 3.95,
  "montreal-extra-mushroom-sauce": 2,
  "montreal-extra-pepper-sauce": 2,
  "montreal-extra-scallop": 3.95,
  "montreal-extra-taramosalata": 2,
  "montreal-extra-tzatziki": 2,
  "montreal-extra-vinaigrette": 2,
  "montreal-filet-mignon-brochette": 34.95,
  "montreal-filet-mignon-medallion": 34.95,
  "montreal-filet-mignon-shrimp": 40.95,
  "montreal-filter-coffee": 2.95,
  "montreal-fish-n-chips": 24.95,
  "montreal-fried-calamari-dinner": 25.95,
  "montreal-frog-legs": 22.95,
  "montreal-galaktoboureko": 4.95,
  "montreal-grilled-chicken-breast": 23.95,
  "montreal-gyro-pita-1": 14.95,
  "montreal-gyro-pita-2": 27.95,
  "montreal-hamburger-steak": 19.95,
  "montreal-ice-cream": 3.95,
  "montreal-juice": 2.95,
  "montreal-lamb-chops": 32.95,
  "montreal-lasagna-gratinee": 22.95,
  "montreal-milk": 2.95,
  "montreal-moussaka": 24.95,
  "montreal-pita-chicken-1": 19.95,
  "montreal-pita-chicken-2": 27.95,
  "montreal-pork-chops": 21.95,
  "montreal-pork-shish-kebab": 24.95,
  "montreal-pouding-chomeur": 3.95,
  "montreal-rice-pudding": 3.95,
  "montreal-salmon-baked": 23.95,
  "montreal-salmon-butterfly-shrimp": 29.95,
  "montreal-scallops-dinner": 22.95,
  "montreal-soft-drink": 2.95,
  "montreal-souvlaki-chicken-1": 19.95,
  "montreal-souvlaki-chicken-2": 25.95,
  "montreal-souvlaki-pork-2": 24.95,
  "montreal-spaghetti-gratinee": 22.95,
  "montreal-spaghetti-meat-sauce": 20.95,
  "montreal-spicy-sausages": 21.95,
  "montreal-steak-cava": 29.95,
  "montreal-tea": 2.95,
  "montreal-white-fish-baked": 18.95,
  "montreal-white-fish-breaded": 20.95,
  "pork-souvlaki-pita-1": 13.95,
  "pork-souvlaki-pita-2": 25.95,
  "pork-souvlaki-plate-1": 17.95,
  "pork-souvlaki-plate-2": 30.95,
  "sauce-meat": 12.95,
  "sauce-mushroom": 9.95,
  "sauce-pepper": 9.95,
  "soup-2l": 22,
  "soup-4l": 32,
};

export const priceOverridesGeneratedAt: string | null = "2026-09-29T21:49:13.557Z";
